import { useRouter } from "next/router";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

const Testimonial = () => {
  const testimonials = [
    {
      title: "Holy Trinity Cathedral, Addis Ababa",
      desc: "A symbol of Ethiopia's Orthodox Christian heritage, the Holy Trinity Cathedral in Addis Ababa is a masterpiece of architectural beauty.",
      img: "/images/testimonials/holy_trinity.jpg",
    },
    {
      title: "Sidama Houses",
      desc: "Sidama houses, traditional dwellings of the Sidama people in Ethiopia, are constructed from natural materials like wood, bamboo, and thatch.",
      img: "/images/testimonials/sidama_houses.jpg",
    },

    {
      title: "Mosque of Al Nejash",
      desc: "A stunning Mosque of Al Nejashi, locally known as simply Negash, is currently standing at the cliff of Negash town, a small town 20 Km next to Wukro on the way to Adigrat. This Mosque is the first built mosque in Africa, as the Axumite Kingdom is the first kingdom to recognize Islam as a religion.",
      img: "/images/testimonials/mosque_alnejash.jpg",
    },

    {
      title: "Yemrehana Krestos Church",
      desc: "Yemrehana Krestos Church, an ancient Christian site, stands as a hidden gem in Ethiopia's architectural heritage.",
      img: "/images/testimonials/yemrehana_krestos.jpg",
    },
    {
      title: "Axum's Obelisks",
      desc: "In the ancient city of Axum, towering obelisks stand as silent sentinels of Ethiopia's glorious past. Carved from single blocks of granite, these monumental structures were erected over 2,000 years ago to honor Ethiopian kings and queens.",
      img: "/images/testimonials/axum_obelisks.jpg",
    },
    {
      title: "King Yohannes Palace",
      desc: "King Yohannes Palace in Mekelle, Ethiopia, is a historic architectural marvel built in the late 19th century by Emperor Yohannes IV.",
      img: "/images/testimonials/king_yohannes_palace.jpg",
    },
    {
      title: "Dorze Vernacular",
      desc: "The Dorze people of Ethiopia are known for their distinctive elephantine huts, towering beehive-shaped dwellings made from bamboo, enset leaves, and woven grass.",
      img: "/images/testimonials/dorze_vernacular.jpg",
    },
    {
      title: "Fasil Ghebbi, Gondar",
      desc: "Fasil Ghebbi, located in Gondar, is a royal fortress and UNESCO World Heritage site known for its impressive stone walls, grand castles, and ornate palaces.",
      img: "/images/testimonials/fasil_ghebbi.jpg",
    },
    {
      title: "Lalibela's Rock-Hewn Churches",
      desc: "Carved directly into the solid rock of the Ethiopian highlands, the churches of Lalibela are a testament to human ingenuity and spiritual devotion.",
      img: "/images/testimonials/lalibela_churches.jpg",
    },
  ];

  return (
    <section className="testimonial-section bg-light-base py-24 dark:bg-jacarta-800">
      <div className="container">
        <div className="mx-auto mb-12 max-w-sm text-center">
          <h2 className="mb-6 text-center font-display text-3xl font-medium text-jacarta-700 dark:text-white">
            Architectural Heritage
          </h2>
          <p className="text-lg dark:text-jacarta-300">
            {`Explore Ethiopia's rich architectural history and heritage.`}
          </p>
        </div>

        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          breakpoints={{
            240: {
              slidesPerView: 1,
            },
            565: {
              slidesPerView: 3,
            },
          }}
          loop={true}
          autoplay={{ delay: 3000 }}
          pagination={{ clickable: true }}
          className="testimonial-carousel"
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-item flex flex-col items-center text-center">
                <img
                  src={item.img}
                  alt={item.title}
                  className="mb-6 h-64 w-full object-cover rounded-lg"
                />
                <h3 className="mb-4 font-display text-xl font-medium text-jacarta-700 dark:text-white">
                  {item.title}
                </h3>
                <p className="text-md text-jacarta-700 dark:text-jacarta-300">
                  {item.desc}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonial;
